import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewLink = _resolveComponent("PreviewLink")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_UserDetailModal = _resolveComponent("UserDetailModal")!
  const _component_RoleDetailModal = _resolveComponent("RoleDetailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      addButtonText: `${_ctx.t('pages.form.assignUserAndRole')}`,
      viewName: "formUsersTable",
      onQueryUpdate: _ctx.syncQuery,
      onFormSubmit: _ctx.submit,
      permissions: _ctx.permissionModel,
      onOnModalShow: _ctx.onModalShow,
      ref: "Datatable"
    }, {
      "cell-assignment": _withCtx(({ row: form }) => [
        _createTextVNode(_toDisplayString(form.assignment) + " ", 1),
        (form.roleId == -1)
          ? (_openBlock(), _createBlock(_component_PreviewLink, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              routerName: {
          name: 'detail.user',
          params: { id: form.userId },
        }
            }, null, 8, ["routerName"]))
          : (_openBlock(), _createBlock(_component_PreviewLink, {
              key: 1,
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              routerName: {
          name: 'detail.roles',
          // params: { id: form.roleId },
        }
            }, null, 8, ["routerName"]))
      ]),
      "cell-createdDate": _withCtx(({ row: form }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.format.DateTime(form.createdDate)), 1)
      ]),
      "cell-siteName": _withCtx(({ row: form }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(form.siteName), 1)
      ]),
      "cell-actions": _withCtx(({ row: form }) => [
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = form;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_5, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "bulkDelete", "tableForm", "addButtonText", "onQueryUpdate", "onFormSubmit", "permissions", "onOnModalShow"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: "formUsers",
      showDialog: _ctx.showDeleteDialog,
      selectedForAction: [_ctx.selectedForAction.webId],
      deleteText: `${_ctx.t('validation.sureToDelete')} ${
      _ctx.selectedForAction.assignment
    }?`,
      pageName: "user/role",
      onClose: _ctx.refreshList
    }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onClose"]),
    _createVNode(_component_UserDetailModal, {
      viewName: "user_detail_modal",
      data: _ctx.selectedUser,
      loading: _ctx.loadingUserDetailModal,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "loading", "showDialog"]),
    _createVNode(_component_RoleDetailModal, {
      viewName: "role_detail_modal",
      data: _ctx.selectedRole,
      loading: _ctx.loadingRoleDetailModal,
      showDialog: _ctx.showRoleDetailDialog,
      onCloseDetail: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showRoleDetailDialog = false))
    }, null, 8, ["data", "loading", "showDialog"])
  ], 64))
}